import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { 
  NAVIGATION_CONTEXTS, 
  ROUTE_PATTERNS, 
  type NavigationContextId,
  type NavigationContext,
  type ContextMenuConfig,
} from "@/constants/navigationContexts";
import { useAuth } from "@/components/auth/AuthProvider";

export interface UseNavigationContextReturn {
  contextId: NavigationContextId;
  context: NavigationContext;
  menuConfig: ContextMenuConfig;
  isAuthenticated: boolean;
}

export function useNavigationContext(): UseNavigationContextReturn {
  const location = useLocation();
  const { user } = useAuth();
  const pathname = location.pathname;

  const contextId = useMemo((): NavigationContextId => {
    // Check each route pattern
    for (const { patterns, contextId } of ROUTE_PATTERNS) {
      for (const pattern of patterns) {
        if (pathname.startsWith(pattern) || pathname.includes(pattern)) {
          return contextId;
        }
      }
    }
    // Default to home context
    return 'home';
  }, [pathname]);

  const context = NAVIGATION_CONTEXTS[contextId];
  const isAuthenticated = !!user;
  const menuConfig = isAuthenticated ? context.registered : context.visitor;

  return {
    contextId,
    context,
    menuConfig,
    isAuthenticated,
  };
}
